import {restPrefixV2} from './urls.js';

const PREFIX = `${restPrefixV2}/webshop/shopping-cart`;

export default {
	getCarts: () => window.axios.get(`${PREFIX}/get-carts-and-addresses?t=${Date.now()}`),
	addToCart: id => window.axios.post(`${PREFIX}/add/${id}`),
	forceAddToCart: ids => window.axios.post(`${PREFIX}/force-add`, ids),
	removeFromCart: params => window.axios.post(`${PREFIX}/remove-by-cartid`, params),
	resetCart: params => window.axios.post(`${PREFIX}/reset-by-cartid`, params)
};



// WEBPACK FOOTER //
// ../source/common/api/cart.api.js